<pcs-icon *ngIf="icon" [icon]="icon"></pcs-icon><ng-content></ng-content>